import axiosClient from '@/api/axiosClient'

export interface UserCapabilitiesResponse {
  isGlobalAdmin: boolean
  isProjectAdmin: boolean
  canSaveForAll: boolean
  canManageUsers: boolean
  canManageRoles: boolean
  canManageImports: boolean
  canManageTables: boolean
  canManageMenu: boolean
  canManageDataViews: boolean
  canManageDataModels: boolean
  canManageValidationRules: boolean
  canManagePowerBI: boolean
}

export interface AccessCheckResponse {
  hasAccess: boolean
  accessLevel?: 'read' | 'write' | 'admin'
  reason?: string
  canRequestAccess?: boolean
}

export interface CheckAccessParams {
  tableKey?: string
  dataViewKey?: string
  reportKey?: string
}

/**
 * Henter eksplisitte tillatelser for brukeren i gjeldende prosjekt.
 * Backend er single source of truth - frontend skal ikke beregne tilgang selv.
 *
 * Krever Ics-Project-Id header (settes automatisk av axios interceptor).
 */
export async function getUserCapabilities (signal?: AbortSignal): Promise<UserCapabilitiesResponse> {
  const response = await axiosClient.get<UserCapabilitiesResponse>('user/capabilities', { signal })
  return response.data
}

/**
 * Sjekker om brukeren har tilgang til en spesifikk ressurs.
 * Returnerer AccessCheckResponse ved 200 OK.
 * Kaster error ved 400/403/404.
 *
 * @param params - Valgfrie parametere for å spesifisere ressurs
 *   - tableKey: Sjekker tilgang til tabell
 *   - dataViewKey: Sjekker tilgang til datavisning
 *   - reportKey: Sjekker tilgang til rapport
 */
export async function checkAccess (params?: CheckAccessParams, signal?: AbortSignal): Promise<AccessCheckResponse> {
  const response = await axiosClient.get<AccessCheckResponse>('user/access-check', {
    params,
    signal
  })
  return response.data
}
